import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "userdata" }
const _hoisted_3 = { class: "name" }
const _hoisted_4 = { class: "login" }
const _hoisted_5 = { class: "bio" }
const _hoisted_6 = { class: "orgs" }
const _hoisted_7 = { class: "orgscontainer" }
const _hoisted_8 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("header", null, [
      _createElementVNode("img", {
        src: _ctx.user.avatar_url
      }, null, 8, _hoisted_1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.user.name), 1),
        _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.user.login), 1),
        _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.user.bio), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgs, (org) => {
          return (_openBlock(), _createElementBlock("a", {
            class: "org",
            key: org,
            style: _normalizeStyle({ backgroundImage: `url(${org.avatar_url})` }),
            href: '//github.com/' + org.login
          }, null, 12, _hoisted_8))
        }), 128))
      ])
    ])
  ], 64))
}